import Vue from "vue";
import HighChartsVue from "highcharts-vue";
import HighCharts from "highcharts";
import StockInit from "highcharts/modules/stock";
import highchartMoreInit from "highcharts/highcharts-more";
import VariablePieInit from "highcharts/modules/variable-pie";
import SolidGuageInit from "highcharts/modules/solid-gauge";
import HighChartsNoData from "highcharts/modules/no-data-to-display";
import colorAxisInit from "highcharts/modules/coloraxis";
import HighChartsExporting from "highcharts/modules/exporting";
import HighChartsPattern from "highcharts/modules/pattern-fill";
import HighChartsBrokenAxis from "highcharts/modules/broken-axis";
import HighChartsAccessibility from "highcharts/modules/accessibility";

StockInit(HighCharts);
HighChartsAccessibility(HighCharts);
HighChartsBrokenAxis(HighCharts);
HighChartsPattern(HighCharts);
HighChartsNoData(HighCharts);
highchartMoreInit(HighCharts);
colorAxisInit(HighCharts);
HighChartsExporting(HighCharts);
VariablePieInit(HighCharts);
SolidGuageInit(HighCharts);

Vue.use(HighChartsVue, { tagName: "high-charts" });
